import { useEffect, useState } from 'react';
import './HomeComponents.css';

const KeyHighlights = () => {
  const [currentStackIndex, setCurrentStackIndex] = useState(0);
  const phoneImages = ['/assets/asset0.jpg', '/assets/asset1.jpg', '/assets/asset2.jpg'];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStackIndex((prev) => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="key-highlights-section">
      <div className="highlights-container">
        <div className="highlights-content">
          <h2>Key <span>Highlights</span></h2>

          <div className="highlight-item">
            <div className="highlight-icon">📍</div>
            <div className="highlight-text">
              <h3>Location-based task discovery</h3>
              <p>Using Maps API for routing, navigation, and proximity-based job listings.</p>
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon">🤖</div>
            <div className="highlight-text">
              <h3>AI-powered task matching</h3>
              <p>Intelligent algorithm matches tasks with the most suitable helpers.</p>
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon">🔒</div>
            <div className="highlight-text">
              <h3>Secure task lifecycle</h3>
              <p>Verified identities, profile ratings, document validation, photo uploads, and status tracking.</p>
            </div>
          </div>
        </div>

        <div className="highlights-visual">
          <div className="highlights-phone-stack">
            {phoneImages.map((img, idx) => {
              let positionClass = '';
              if (idx === currentStackIndex) positionClass = 'active';
              else if (idx === (currentStackIndex + 1) % 3) positionClass = 'next';
              else positionClass = 'prev';
              
              return (
                <div key={idx} className={`stack-phone ${positionClass}`}>
                  <img src={img} alt={`App screen ${idx + 1}`} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyHighlights;